angular.module('PTK.services.Service', [])

.factory('Service', ['$log', '$http', '$location', '$cookies', '$rootScope', '$window', 'Package',  function($log, $http, $location, $cookies, $rootScope, $window, Package){


  var Service = {
		//remote_host: 'https://tesim.panemnet.hu/elearning/',
		//remote_host: 'https://www.tudasportal.hu/',
		//remote_host: 'https://gyulatk.tudasspektrum.hu/',
		remote_host: 'https://bekescsabatk.tudasspektrum.hu/',
		link_host: $location.protocol() + "://" + $location.host() + ":" + $location.port() + "/",
		packages: [],
		users: [],
		pages: [],
		templates: [],
		styles: [],
		valasztottcsomag: '',
		valasztottlap: '',
		files: [],
		bgfiles: [],
		loggedin: false,
		playermode: false,
		loginmessage: "Adja meg a belépési adatokat, majd kattinson a Belépés gombra!",
		logindata: {},
		offline: false, //OFFLINE
		session_id: "",
		demotext: "",
		quiztext: "",
		pagelist: [],
		pickedfile: "",
/*playerbe
		jsonpackages: [],
		jsonpages: [], 
		jsonstyles: [],
		jsontemplates: [],
		jsonpid: ""
playerbe*/
	};
	
/*playerbe

	//console.log ("Importálás playerbe");
	if (Package.jsonpid){
		Service.jsonpid = Package.jsonpid;
		Service.jsonpackages = Package.jsonpackages;
		Service.jsonpages = Package.jsonpages;
		Service.jsonstyles = Package.jsonstyles;
		Service.jsontemplates = Package.jsontemplates;
	}

playerbe*/

	$window.addEventListener('onPickItem', function(e) {
		//console.log (e.detail);
        //$rootScope.$broadcast('onPickItem', e.detail);
		Service.pickedfile = "content"+e.detail.fullPath();
		//console.log ( Service);
    });
	
	//$rootScope.$on('onPickItem', function(a, b) {
		//console.log (a);
	//});	
	
	/*
	$http.defaults.headers.post["Content-Type"] = "text/plain";		
	$http.post(  Service.remote_host+"getdata.php?isactive=" + $cookies.get("session") )
		.success(function(data, status, headers, config) {
			Service.loggedin = parseInt(data.code);
			Service.loginmessage = data.message;
			Service.session = data.session;
			Service.logindata = {name: data.name, login: data.login, email: data.email};
			$log.log (data);
		}).error(function(data, status, headers, config) {
			Service.loginmessage = "";//"Belépési hiba";
			Service.loggedin = 0;
			Service.logindata = [];
		});
	*/		
	
	Service.kilepes = function(){
		
		$cookies.put("loggedin", false );
		$cookies.put("loginname", "" );
		$cookies.put("name", "" );
		$cookies.put("session_id", "" );
		
		Service.loggedin = false;
		Service.logindata.superuser = false;
		Service.logindata.login = "";
		Service.logindata.name = "";
		Service.logindata.id = 0;
		Service.session_id = "";

		$location.path('/login');
		
	}
	
	
   	Service.guid = function() {
	  function s4() {
		return Math.floor((1 + Math.random()) * 0x10000)
		  .toString(16)
		  .substring(1);
	  }
	  return s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4();
	} 

	//Service.azonosito = Service.guid();

	
	Service.getres = function (param){
	
/*playerbe
		Service.files = [];
playerbe*/

/* test-code */	
		$http.defaults.headers.post["Content-Type"] = "text/plain";
		
		$http.get( Service.remote_host + "getdata.php?type=files&id="+param+"&sessid="+Service.session_id)
			.then(function (response) {
				Service.files = response.data;
				
				//$log.log (param, param2, param3);
				//$log.log (Service.files);
				
				/*
				if (param2 !="" && param3!=""){
					var img = new Image();
					
					var tmpstring = param2.replace(/ /g,"%20");
					
					if (param3 == "package"){
						img.src = Service.remote_host + "content/" + param+ "/" + tmpstring + "?" + new Date().getTime();;
					}else{
						img.src = Service.remote_host + "content/common/" + tmpstring + "?" + new Date().getTime();;
					}
					
				}
				*/
	});
			
/* end-test-code */		
	};

/* test-code */		
  	Service.listpages = function (id) {
		if (!id) return;
		
		$http.defaults.headers.post["Content-Type"] = "text/plain";
		$http.get(Service.remote_host + "getdata.php?type=pages&pid="+id+"&sessid="+Service.session_id)
			.then(function (response) {
				Service.pagelist = response.data;
			});
	}; 	
/* end-test-code */	
	
  	Service.getpackages = function (id) {
		if (Service.hasOwnProperty('jsonpackages') && Service.offline && Service.jsonpackages.length ){
			Service.packages = Service.jsonpackages;           
		}else{
				$http.defaults.headers.post["Content-Type"] = "text/plain";
				$http.get( Service.remote_host + "getdata.php?sessid="+Service.session_id+"&id="+id)
					.then(function (response) {
						Service.packages = response.data;
					});
		}
	}; 

  	Service.gettemplates = function (id) {
		if (Service.hasOwnProperty('jsontemplates') && Service.offline ){ //&& Service.jsontemplates.length ){
			Service.templates = Service.jsontemplates;         
		}else{
			$http.defaults.headers.post["Content-Type"] = "text/plain";
			$http.get( Service.remote_host + "getdata.php?type=templates&sessid="+Service.session_id+"&pid="+id)
				.then(function (response) {
					Service.templates = response.data;
				});
		}
	}; 

/* test-code */	

	Service.getusers = function (id) {		
		$http.defaults.headers.post["Content-Type"] = "text/plain";
		$http.get( Service.remote_host + "getdata.php?type=users&sessid="+Service.session_id)
			.then(function (response) {
				Service.users = response.data;
				
				//console.log (Service.loggedin);
				//console.log (Service.logindata);
				
				for (var i = 0, len = Service.users.length; i < len; i++) {
					if (Service.users[i].admin_id == Service.logindata.id ) {
						Service.logindata = {id:Service.users[i].admin_id, name: Service.users[i].admin_name, login: Service.users[i].admin_login, superuser: parseInt(Service.users[i].admin_super)};
					}
				}
			});
	}; 

/* end-test-code */

  	Service.getstyles = function (id) {
		if (Service.hasOwnProperty('jsonstyles') && Service.offline ){ //&& Service.jsonstyles.length ){
			Service.styles = Service.jsonstyles;  
		}else{
			$http.defaults.headers.post["Content-Type"] = "text/plain";
			$http.get( Service.remote_host + "getdata.php?type=styles&sessid="+Service.session_id+"&pid="+id)
				.then(function (response) {
					Service.styles = response.data;
				});
		}
	}; 
	
  	Service.getpages = function (id) {
		if (!id) return;
		
		if (Service.hasOwnProperty('jsonpages') && Service.offline && Service.jsonpages.length ){
			Service.pages = [];
			
			for (var i = 0, len = Service.jsonpages.length; i < len; i++) {
				//if (Service.jsonpages[i].page_package_id == id && Service.jsonpages[i].page_hidden == "0" ) {
				if (Service.jsonpages[i].page_package_id == id ) {
					
					var myobject = Service.jsonpages[i];
					var myitems = myobject.page_items;
					console.log ("before:"+myitems);
					myitems = myitems.replace(/(src=["'])http[s]?:\/\/[^'"]*?\/content\//g,"$1"+"content/");
				    myitems = myitems.replace(/(\})http[s]?:\/\/[^\}\{]*?\/content\//g,"$1"+"content/");
					console.log ("after:"+myitems);
					myobject.page_items = myitems;
					Service.pages.push(myobject);
				}
			}
			
			Service.pages.sort(function(a, b){
				return ( parseInt( a.page_order ) - parseInt( b.page_order ) );
			});
		}else{
			$http.defaults.headers.post["Content-Type"] = "text/plain";
			$http.get( Service.remote_host + "getdata.php?type=pages&pid="+id+"&sessid="+Service.session_id)
				.then(function (response) {
					//Service.pages = response.data;
					
					var tmparray=[];
					
					for (var i = 0, len = response.data.length; i < len; i++) {
						//if (response.data[i].page_hidden!="1") {
							tmparray.push(response.data[i]);
						//}
					}

					Service.pages = tmparray;
					
				});
		}
	}; 	
/* test-code */		
	 Service.updatepackage = function ( obj ) {
		
		$http.defaults.headers.post["Content-Type"] = "text/plain";
		
		$http.post( Service.remote_host + "putdata.php?type=package&id="+obj.package_id+"&task=update&sessid="+Service.session_id, JSON.stringify( obj, true))
			.success(function(data, status, headers, config) {
				//$log.log (data);
				//Service.getpackages();
			}).error(function(data, status, headers, config) {
				$log.log ("Csomag mentés hiba.");
			});
			
		return "ok";
	}; 

	
	Service.login = function ( $login, $password, $sessid ) {
		
		var hibakod;
		
		$http.defaults.headers.post["Content-Type"] = "text/plain";
		
		$http.post( Service.remote_host + "putdata.php?type=login", JSON.stringify( {id: $login, pass: $password, sessid: $sessid}, true))
			.success(function(data, status, headers, config) {
				//$log.log (data);
				Service.loggedin = data.code;
				Service.loginmessage = data.message;
				Service.logindata = {id:data.id, name: data.name, login: data.login, superuser: parseInt(data.superuser) };
				Service.session_id = data.session_id;
				hibakod = 0;
			}).error(function(data, status, headers, config) {
				$log.log ("Belépési hiba.");
				hibakod = 1;
			});
			
		return hibakod;
	}; 
	
	
	Service.updatetemplate = function ( obj ) {
		
		$http.defaults.headers.post["Content-Type"] = "text/plain";
		
		$http.post( Service.remote_host + "putdata.php?type=template&id="+obj.template_id+"&task=update&sessid="+Service.session_id, JSON.stringify( obj, true))
			.success(function(data, status, headers, config) {
				//$log.log (data);
			}).error(function(data, status, headers, config) {
				$log.log ("Template mentés hiba.");
			});
			
		return "ok";
	}; 


	Service.updatestyle = function ( obj ) {
		
		$http.defaults.headers.post["Content-Type"] = "text/plain";
		
		$http.post( Service.remote_host + "putdata.php?type=style&id="+obj.style_id+"&task=update&sessid="+Service.session_id, JSON.stringify( obj, true))
			.success(function(data, status, headers, config) {
				//$log.log (data);
			}).error(function(data, status, headers, config) {
				$log.log ("Style mentés hiba.");
			});
			
		return "ok";
	}; 

	Service.updateuser = function ( obj ) {
		
		//$log.log(obj);
		
		obj.sessid = Service.session_id;
		
		$http.defaults.headers.post["Content-Type"] = "text/plain";
		
		$http.post( Service.remote_host + "putdata.php?type=user&id="+obj.admin_id+"&task=update", JSON.stringify( obj, true))
			.success(function(data, status, headers, config) {
				
				//$log.log (data);
				Service.getusers();
				
			}).error(function(data, status, headers, config) {
				$log.log ("User mentés hiba.");
			});
			
		return "ok";
	}; 
	
	Service.updatepage = function ( obj ) {
		
		$http.defaults.headers.post["Content-Type"] = "text/plain";
		
		//var tempobject = obj;
		//tempobject.page_items = JSON.stringify( tempobject.page_items, true);
		
		$http.post( Service.remote_host + "putdata.php?type=page&id="+obj.page_id+"&task=update&sessid="+Service.session_id, JSON.stringify( obj, true))
			.success(function(data, status, headers, config) {
				//$log.log (data);
			}).error(function(data, status, headers, config) {
				$log.log ("Lap mentés hiba.");
			});
			
		return "ok";
	}; 

	Service.saveitems = function ( pkgid, id, obj ) {
		
		$http.defaults.headers.post["Content-Type"] = "text/plain";
				
		$http.post( Service.remote_host + "putdata.php?type=items&pkgid="+pkgid+"&id="+id+"&task=update&sessid="+Service.session_id, JSON.stringify( obj, true))
			.success(function(data, status, headers, config) {
				//$log.log (data);
			}).error(function(data, status, headers, config) {
				$log.log ("Items mentés hiba.");
			});
			
		return "ok";
	}; 
	
	 Service.delpackage = function ( id ) {
		$http.defaults.headers.post["Content-Type"] = "text/plain";
		$http.post( Service.remote_host + "putdata.php?type=package&id="+id+"&task=delete", JSON.stringify( {sessid: Service.session_id}, true))
			.success(function(data, status, headers, config) {
				//$log.log (data);
			}).error(function(data, status, headers, config) {
				$log.log ("Csomag törlés hiba.");
			});
			
		return "ok";
	}; 	

	Service.deltemplate = function ( id ) {
		$http.defaults.headers.post["Content-Type"] = "text/plain";
		$http.post( Service.remote_host + "putdata.php?type=template&id="+id+"&task=delete", JSON.stringify( {sessid: Service.session_id}, true))
			.success(function(data, status, headers, config) {
				//$log.log (data);
			}).error(function(data, status, headers, config) {
				$log.log ("Sablon törlés hiba.");
			});
			
		return "ok";
	}; 	
	
	Service.delstyle = function ( id ) {
		$http.defaults.headers.post["Content-Type"] = "text/plain";
		$http.post( Service.remote_host + "putdata.php?type=style&id="+id+"&task=delete", JSON.stringify( {sessid: Service.session_id}, true))
			.success(function(data, status, headers, config) {
				//$log.log (data);
			}).error(function(data, status, headers, config) {
				$log.log ("Stílus törlés hiba.");
			});
			
		return "ok";
	}; 	

	Service.deluser = function ( id ) {
		$http.defaults.headers.post["Content-Type"] = "text/plain";
		$http.post( Service.remote_host + "putdata.php?type=user&id="+id+"&task=delete", JSON.stringify( {sessid: Service.session_id}, true))
			.success(function(data, status, headers, config) {
				//$log.log (data);
			}).error(function(data, status, headers, config) {
				$log.log ("User törlés hiba.");
			});
			
		return "ok";
	}; 	
	
	 Service.delpage = function ( id ) {
		$http.defaults.headers.post["Content-Type"] = "text/plain";
		$http.post( Service.remote_host + "putdata.php?type=page&id="+id+"&task=delete", JSON.stringify( {sessid: Service.session_id}, true))
			.success(function(data, status, headers, config) {
				//$log.log (data);
			}).error(function(data, status, headers, config) {
				$log.log ("Lap törlés hiba.");
			});
			
		return "ok";
	}; 	
/* end-test-code */	

  return Service;
}]);



